// extracted by mini-css-extract-plugin
module.exports = {"price":"invoicerecapitulationitem_price__2NyYz","taxablePrice":"invoicerecapitulationitem_taxablePrice__34yZd"};